<template>
    <div class="d-flex align-items-center">
        <template v-if="row.Past && !row.Paid">
            <span class="material-icons-round mr-50 text-danger">close</span>
            <span class="text-danger text-nowrap">Ödeme tarinde ödenmedi.</span>
        </template>
        <template v-else-if="row.Past && row.Paid">
            <span class="material-icons-round mr-50 text-secondary">done</span>
            <span class="text-secondary text-nowrap">Geç ödendi.</span>
        </template>
        <template v-else-if="!row.Past && row.Paid">
            <span class="material-icons-round mr-50 text-success">done</span>
            <span class="text-success text-nowrap">Ödendi.</span>
        </template>
        <template v-else>
            <span class="material-icons-round mr-50 text-muted">schedule</span>
            <span class="text-muted text-nowrap">Ödeme bekleniyor.</span>
        </template>
    </div>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object
    },
}
</script>

<style>

</style>